export const HOME_ROUTE = '/'
export const UNITS_ROUTE = '/units'
export const REGISTER_ROUTE = '/register'
export const LOGIN_ROUTE = '/login'
export const ACTIVATE_ACCOUNT_ROUTE = '/activate-account'
export const LOGOUT_ROUTE = '/logout'
export const PORTAL_ROUTE = '/portal'
export const ADMIN_ROUTE = '/admin'
export const ADMIN_SUBSCRIPTIONS_ROUTE = `${ADMIN_ROUTE}/subscriptions`
export const ADMIN_ALL_UNITS_ROUTE = `${ADMIN_ROUTE}/allunits`
export const ADMIN_CANCELLATIONS_ROUTE = `${ADMIN_ROUTE}/cancellations`
export const ADMIN_VIEW_ROUTE = `${ADMIN_ROUTE}/:adminViewSlug`
